module.exports = __webpack_public_path__ + "img/user-default.52a6cba8.jpg";